import { ExternalAuthState } from "./external-auth-state";


/**
 * Compare two auth state objects and determine if they are equivalent
 */
export function externalAuthStateEquality(s1: ExternalAuthState, s2: ExternalAuthState) {

	if (s1.status !== s2.status) return false;
	if (s1.status == 'error') return false;

	if (s1.status == 'signed-in' && s2.status == 'signed-in') {
		if (s1.user.emailVerified !== s2.user.emailVerified) return false;
		if (s1.user.email !== s2.user.email) return false;
	}

	return true;
}